import { type ReactNode } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { APP_ROUTES } from "@/common/urls"
import { Skeleton } from "@/components/ui/skeleton"
import { useAuth } from "@/hooks/useAuth"

interface ProtectedRouteProps {
    readonly children: ReactNode
}

export default function AuthRoutesProtector({ children }: ProtectedRouteProps) {
    const { user, loading } = useAuth()
    const location = useLocation()

    if (loading) {
        return <Skeleton className="w-full h-full" />
    }

    if (
        user &&
        (location.pathname === APP_ROUTES.AUTH.LOGIN ||
            location.pathname === APP_ROUTES.AUTH.REGISTER)
    ) {
        return <Navigate to={APP_ROUTES.ROOT.DASHBOARD} replace />
    }

    return <>{children}</>
}
